export enum PatientEventCodeCategory {
  Sleep = 30,
  Inhaler = 10,
  MaintenanceInhaler = 102,
  RelieverInhaler = 101,
  AbnormalInhaler = 104,
  Correlated = 40,
}
